import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BcDevRequest, BcDevRequestFile, BcDevRequestUpdate, BcDevRequestUpdateStatusRequest } from '@models/products-and-orders/requests';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BcDevRequestsService {
  private readonly url = `${environment.bffUrl}/bc-dev-requests`;

  constructor(private httpClient: HttpClient) {}

  getOne(id: string): Observable<BcDevRequest> {
    return this.httpClient.get<BcDevRequest>(`${this.url}/${id}`);
  }

  updateStatus(id: string, data: BcDevRequestUpdateStatusRequest): Observable<BcDevRequest> {
    return this.httpClient.post<BcDevRequest>(`${this.url}/${id}/update-status`, data);
  }

  getFiles(id: string): Observable<BcDevRequestFile[]> {
    return this.httpClient.get<BcDevRequestFile[]>(`${this.url}/${id}/files`);
  }

  deleteFile(id: string, fileId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}/files/${fileId}`);
  }

  bulkDeleteFiles(id: string, fileIds: string[]): Observable<void[]> {
    return this.httpClient.post<void[]>(`${this.url}/${id}/files`, fileIds);
  }

  getSubmittedUpdates(id: string): Observable<BcDevRequestUpdate[]> {
    return this.httpClient.get<BcDevRequestUpdate[]>(`${this.url}/${id}/updates`);
  }
}
